<app-header></app-header>
<app-cover></app-cover>
<app-informations></app-informations>
<app-footer></app-footer>
